<template>
    
        <el-scrollbar :style="'height:'+bodyHeight+'px;'">
        <div style="width:98%">
            <el-row :gutter="20">
                <el-col :span="24">
                    <div class="grid-content bg-purple">
                        <el-card class="box-card" shadow="hover">
                            <div slot="header" class="clearfix">
                                <span>十五天账目概览</span>
                            </div>
                            <ve-line :data="accountsData"  :settings="{area: true,
                                labelMap: {
                                    Date:'日期',
                                    ActualCommission: '佣金收入',
                                    SwipeCommission: '佣金支出',
                                    SwipePromote: '刷手推广费',
                                    SwipePraise: '刷手好评费',
                                    MerchantPromote: '商家推广费',
                                    MerchantPraise: '好评收入',
                                    GrossProfit: '毛利',
                                },
                                yAxisType: ['0.[00]a'],
                            }"></ve-line>
                        </el-card>
                    </div>
                </el-col>
            </el-row>

            <el-row :gutter="20">
                <el-col :span="24">
                    <div class="grid-content bg-purple">
                        <el-card class="box-card" shadow="hover">
                            <div slot="header" class="clearfix">
                                <span>十五天注册刷手趋势</span>
                            </div>
                            <ve-line :data="swipeData"  :settings="{area: false,
                                labelMap: {
                                    Date:'日期',
                                    RegisterNum: '注册会员',
                                    EffectiveNum: '有效会员',
                                    ConversionRate: '转换率'
                                },
                                axisSite: {
                                    right: ['ConversionRate'],
                                },
                                yAxisType: ['0.[00]a', '0.[00]%'],
                            }"></ve-line>
                        </el-card>
                    </div>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="24">
                    <div class="grid-content bg-purple">
                        <el-card class="box-card" shadow="hover">
                            <div slot="header" class="clearfix">
                                <span>十五天活跃刷手趋势</span>
                            </div>
                            <ve-line :data="swipeActiveData" height="320px" :settings="{
                                labelMap: {
                                    StartNum: '活跃会员',
                                    OkNum: '完单会员',
                                    ConversionRate: '成功率'
                                },
                                axisSite: {
                                    right: ['ConversionRate']
                                },
                                yAxisType: ['0.[00]a', '0.[00]%'],
                            }"></ve-line>
                        </el-card>
                    </div>
                </el-col>
            </el-row>
        </div>
        </el-scrollbar>
        <!-- <el-row :gutter="20">
            <el-col :span="16">
                <div class="grid-content bg-purple">
                    <el-card class="box-card" shadow="hover">
                        <div slot="header" class="clearfix">
                            <span>十五天总单量趋势</span>
                        </div>
                        <ve-line  legend-visible="false" :data="chartData"></ve-line>
                    </el-card>
                </div>
            </el-col>
            <el-col :span="8">
                <div class="grid-content bg-purple">
                    <el-card class="box-card" shadow="hover">
                        <div slot="header" class="clearfix">
                            <span>当日总订单</span>
                            <el-progress :percentage="100" status="success" :format="format"></el-progress>
                            <el-progress :percentage="50" status="exception" :format="format"></el-progress>
                        </div>
                    </el-card>
                </div>
                <div class="grid-content bg-purple">
                    <el-card class="box-card" shadow="hover">
                        <div slot="header" class="clearfix">
                            <span>当日任务本金</span>
                        </div>
                    </el-card>
                </div>
                <div class="grid-content bg-purple">
                    <el-card class="box-card" shadow="hover">
                        <div slot="header" class="clearfix">
                            <span>当日总订单</span>
                        </div>
                    </el-card>
                </div>
            </el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :span="24"><div class="grid-content bg-purple"></div></el-col>
        </el-row> -->
    
</template>
<script>
import { indexGetActiveSwipeChart ,indexGetSwipeChart,indexGetAccountsChart} from '@/request.js'

export default {
    data() {
        return {
            bodyHeight:0,
            swipeData: {
                columns: ['Date', 'RegisterNum','EffectiveNum','ConversionRate'],
                rows: []
            },
            swipeActiveData: {
                columns: ['Date', 'StartNum','OkNum','ConversionRate'],
                 rows: []
            },
            accountsData: {
                columns: ['Date', 'ActualCommission','MerchantPraise','MerchantPromote','SwipeCommission','SwipePromote','SwipePraise','GrossProfit'],
                 rows: []
            },
        }
   },
   mounted(){
       this.bodyHeight=document.documentElement.clientHeight-100;
       indexGetAccountsChart({},(res)=>{
           this.accountsData.rows=res.Result;
       });
       indexGetActiveSwipeChart({},(res)=>{
           this.swipeActiveData.rows=res.Result;
       });
       indexGetSwipeChart({},(res)=>{
           this.swipeData.rows=res.Result;
       });
   },
   methods: {
       
      estimate(percentage) {
        return '预计'+percentage;
      },
      actual(percentage) {
        return '实际'+percentage;
      }
    }
}
</script>
<style>
  .el-row {
    margin-bottom: 20px;
  }
  .el-col {
    border-radius: 4px;
  }
  .grid-content {
    border-radius: 4px;
  }
  .row-bg {
    padding: 10px 0;
  }
</style>